import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHitachiComponent } from './simple-icons-hitachi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHitachiComponent ],
    exports:      [ SimpleIconsHitachiComponent ],
    bootstrap:    []
})
export class SimpleIconsHitachiModule {}
